import * as React from "react";
import { Box, Button, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import useAssessmentLabel from "../../../hooks/useAssessmentLabel";
import IntraOralAdvancedForm, { IntraOralAdvancedData } from "./IntraOralAdvancedForm";
import { hasContentAdvancedIntraOral } from "../../Modals/Assessment/AdvancedIntraOralContent";

// @ts-expect-error - css
import styles from "../Assessment.module.css";

interface Props {
  data: IntraOralAdvancedData;
  onChange: (v: IntraOralAdvancedData) => void;
  onCancel: () => void;
}

function AdvancedIntraOralSummary({ data }: { data: IntraOralAdvancedData }) {
  const fields: [keyof IntraOralAdvancedData, string][] = [
    ["abfraction", "Abfraction"],
    ["abrasion", "Abrasion"],
    ["attrition", "Attrition"],
    ["calculus", "Calculus"],
    ["cariesRisk", "Caries Risk"],
    ["erosion", "Erosion"],
    ["occlusion", "Occlusion"],
    ["recallGap", "Recall Gap"],
    ["stain", "Stain"],
    ["softTissueExamination", "Soft Tissue Examination"]
  ];

  const summaryParts = fields
    .filter(([key]) => data[key])
    .map(([key, label]) => (
      <React.Fragment key={key}>
        <strong>{label}:</strong> {data[key] as string}.{" "}
      </React.Fragment>
    ));

  return (
    <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
      {summaryParts.length > 0 ? summaryParts : "No advanced intra-oral data available."}
    </Typography>
  );
}

export default function IntraOralAdvanced(props: Props): React.JSX.Element {
  const { data, onChange, onCancel } = props;
  const [showForm, setShowForm] = React.useState(false);
  const assessmentLabels = useAssessmentLabel();
  const hasData = React.useMemo(() => hasContentAdvancedIntraOral(data), [data]);

  return (
    <Box className={styles.assessmentRow} height="auto">
      <Box className={styles.assessmentLabel}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.advancedIntraOral}{" "}
        </Typography>
      </Box>

      <Box className={styles.assessmentField} display="flex" flexDirection="column" gap={1}>
        <Box display="flex" alignItems="center" gap={1}>
          <Button onClick={() => setShowForm(true)}>Intra Oral Form View</Button>
          {hasData && <CheckCircleOutlineIcon color="primary" />}
        </Box>

        {hasData && <AdvancedIntraOralSummary data={data} />}
      </Box>

      <IntraOralAdvancedForm
        open={showForm}
        handleClose={() => setShowForm(false)}
        data={data}
        onChange={onChange}
        onCancel={onCancel}
      />
    </Box>
  );
}
